import Component from "@glimmer/component";
import { htmlSafe } from "@ember/template";

export default class WazeCategoryBox extends Component {
  get style() {
    if (this.args.category.color) {
      return htmlSafe(`background-color: #${this.args.category.color}`);
    }
    return null;
  }

  // Referenced from https://github.com/discourse/discourse-minimal-category-boxes/blob/bfc94b02e49eb648e4e0a91bcafc58bae9bfbac1/javascripts/discourse/components/category-box.js
  get abbreviation() {
    let abbr = this.args.category.name
      .toLocaleLowerCase()
      .replace(new RegExp("[\"'`&#$+\\-=()/*]", "g"), "")
      .replace(/(_|-| and | of | for |:)/g, " ")
      .split(" ")
      .filter((part) => part.length);

    if (abbr.length === 0) {
      return "";
    }

    if (abbr.length > 1) {
      abbr =
        abbr[0].charAt(0).toLocaleUpperCase() +
        abbr[1].charAt(0).toLocaleUpperCase();
    } else {
      abbr =
        abbr[0].charAt(0).toLocaleUpperCase() +
        abbr[0].charAt(1).toLocaleUpperCase();
    }

    return abbr;
  }

  <template>
    <a
      href={{@category.url}}
      class="waze-semi-category-dialog-content-category"
      data-category-id={{@category.id}}
      data-notification-level={{@category.notificationLevelString}}
      data-url={{@category.url}}
    >
      <div class="waze-semi-category-dialog-content-category-logo">
        {{#if @category.uploaded_logo.url}}
          <img src={{@category.uploaded_logo.url}} alt="" />
        {{else}}
          <div
            class="waze-semi-category-dialog-content-category-abbreviation"
            style={{this.style}}
          >
            {{this.abbreviation}}
          </div>
        {{/if}}
      </div>
      <wz-body2 class="waze-semi-category-dialog-content-category-name">
        {{@category.name}}
      </wz-body2>
    </a>
  </template>
}
